import {Component} from 'react';
import isLargeText from '../../objects/CommonUse/is_large_text';


class WaitTimeSpinner extends Component {
    constructor(props) {
        super(props);
        this.state = {loading: true,
           };
        this.setTextSize();
    }

    setTextSize(){
        this.className = "decorative spinner-text-position";
        if (isLargeText() === true){
            this.className += " spinner-text-size2";
        }else{
            this.className += " spinner-text-size";
        }
    }

    render() { 
        
    return <>
        <div className="wait-spinner-container spinner-position">
            <img   src="./assets/TrainOnCircleTrack.png"
                    className="money-train-spinner" alt="moneyTrain"/>
      
            <span className={this.className}>MoneyTrain</span>
        </div>
    </>
    }
  
}
 
export default WaitTimeSpinner;